const products = [
    
  {
    id: 2,
    name: 'OG Kush',
    strain: 'Indica',
    // thcContent: 18,
    priceOptions: [
      { option: '1oz', price: 200 },
      { option: '1/2oz', price: 110 },
      { option: '1/4oz', price: 60 },
      // { option: '1/8oz', price: 25 }

    ],
    image: '/images/icek.png',
    category: 'Exotic-Flower',
    isNew: true,
    description: 'OG Kush is an indica-heavy hybrid with a breakdown of around 85% indica to 15% sativa.',
    effects: ['Euphoric', 'Deep relaxation', 'Pain relief'],
    flavors: ['Blueberry', 'Sweet', 'Herbal']
  },
  {
    id: 3,
    name: 'Lemon Cherry Gelato',
    strain: 'Hybrid',
    // thcContent: 18,
    priceOptions: [
      { option: '1oz', price: 200 },
      { option: '1/2oz', price: 110 },
      { option: '1/4oz', price: 60 },
      // { option: '1/8oz', price: 25 },
    ],
    image: '/images/phaze.png',
    category: 'Exotic-Flower',
    isNew: true,
    description: 'Lemon Cherry Gelato is a balanced hybrid strain with sky-high potency, dessert-like flavors, and relaxing yet uplifting effects.',
    effects: ['Euphoric', 'Creative', 'Energetic'],
    flavors: ['Blueberry', 'Sweet', 'Herbal']
  },
  {
    id: 4,
    name: 'Maui',
    strain: 'Sativa',
    // thcContent: 18,
    priceOptions: [
      { option: '1oz', price: 200 },
      { option: '1/2oz', price: 110 },
      { option: '1/4oz', price: 60 },
      // { option: '1/8oz', price: 25 },

    ],
    image: '/images/pipes.png',
    category: 'Exotic-Flower',
    isNew: true,
    description: 'Maui is a legendary sativa-dominant strain known for its tropical flavors and uplifting effects.',
    effects: ['Euphoric', 'Creative', 'Energetic'],
    flavors: ['Blueberry', 'Sweet', 'Herbal']
  },
  {
    id: 5,
    name: 'GMO Cookies',
    strain: 'Indica',
    // thcContent: 18,
    priceOptions: [
      { option: '1oz', price: 200 },
      { option: '1/2oz', price: 110 },
      { option: '1/4oz', price: 60 },
      // { option: '1/8oz', price: 25 },
    ],
    image: '/images/placeholder.png',
    category: 'Exotic-Flower',
    isNew: true,
    description: 'GMO Cookie strain is a heavy hitter that is roughly 90% indica and 10% sativa.',
    effects: ['Euphoric', 'Deep relaxation', 'Pain relief'],
    flavors: ['Blueberry', 'Sweet', 'Herbal']
  },
  // Flower (8 products)
  {
    id: 6,
    name: 'Taho OG',
    strain: 'Sativa',
    // thcContent: 18,
    priceOptions: [
      { option: '1oz', price: 150 },
      { option: '1/2oz', price: 80 },
      { option: '1/4oz', price: 50 },
      // { option: '1/8oz', price: 20 },
    ],
    image: '/images/blue.png',
    category: 'Flower',
    isNew: true,
    description: 'A sativa-dominant hybrid with a sweet berry aroma and euphoric effects.',
    effects: ['Euphoric', 'Creative', 'Energetic'],
    flavors: ['Blueberry', 'Sweet', 'Herbal']
  },
  {
    id: 7,
    name: 'Lemon OG',
    strain: 'Indica',
    // thcContent: 23,
    priceOptions: [
      { option: '1oz', price: 150 },
      { option: '1/2oz', price: 80 },
      { option: '1/4oz', price: 50 },
      // { option: '1/8oz', price: 20 },
    ],
    image: '/images/og.png',
    category: 'Flower',
    description: 'A classic indica strain with earthy pine aromas and relaxing effects.',
    effects: ['Relaxing', 'Sleepy', 'Happy'],
    flavors: ['Earthy', 'Pine', 'Woody']
  },
  {
    id: 8,
    name: 'Sour Diesel',
    strain: 'Indica',
    // thcContent: 20,
    priceOptions: [
      { option: '1oz', price: 150 },
      { option: '1/2oz', price: 80 },
      { option: '1/4oz', price: 50 },
    ],
    image: '/images/sdd.png',
    category: 'Flower',
    isNew: true,
    description: 'A potent sativa with diesel-like aroma and energizing effects.',
    effects: ['Energetic', 'Creative', 'Uplifted'],
    flavors: ['Diesel', 'Citrus', 'Pungent']
  },
  {
    id: 9,
    name: 'Granddaddy Purple',
    strain: 'Indica',
    // thcContent: 22,
    priceOptions: [
      { option: '1oz', price: 100 },
      { option: '1/2oz', price: 60 },
      { option: '1/4oz', price: 40 },
    ],
    image: '/images/gpp.png',
    category: 'Flower',
    description: 'A famous indica with grape and berry flavors, perfect for relaxation.',
    effects: ['Relaxing', 'Sleepy', 'Euphoric'],
    flavors: ['Grape', 'Berry', 'Sweet']
  },
  {
    id: 10,
    name: 'Green Crack',
    strain: 'Sativa',
    // thcContent: 19,
    priceOptions: [
      { option: '1oz', price: 100 },
      { option: '1/2oz', price: 60 },
      { option: '1/4oz', price: 40 },
    ],
    image: '/images/gcc.png',
    category: 'Flower',
    description: 'An energetic sativa with mango and citrus flavors.',
    effects: ['Energetic', 'Focused', 'Happy'],
    flavors: ['Mango', 'Citrus', 'Tropical']
  },
  {
    id: 11,
    name: 'Northern Lights',
    strain: 'Indica',
    // thcContent: 21,
    priceOptions: [
      { option: '1oz', price: 100 },
      { option: '1/2oz', price: 60 },
      { option: '1/4oz', price: 40 },
    ],
    image: '/images/nlight.png',
    category: 'Flower',
    description: 'A classic indica known for its relaxing and sleep-inducing effects.',
    effects: ['Relaxing', 'Sleepy', 'Peaceful'],
    flavors: ['Earthy', 'Sweet', 'Pine']
  },
  {
    id: 12,
    name: 'Jack Herer',
    strain: 'Sativa',
    // thcContent: 18,
    priceOptions: [
      { option: '1oz', price: 100 },
      { option: '1/2oz', price: 60 },
      { option: '1/4oz', price: 40 },
    ],
    image: '/images/jack.png',
    category: 'Flower',
    isNew: true,
    description: 'A legendary sativa with spicy pine flavor and clear-headed effects.',
    effects: ['Creative', 'Focused', 'Uplifted'],
    flavors: ['Pine', 'Spicy', 'Woody']
  }
  ,
  {
    id: 13,
    name: 'Wedding Cake',
    strain: 'Hybrid',
    // thcContent: 25,
    priceOptions: [
      { option: '1oz', price: 100 },
      { option: '1/2oz', price: 60 },
      { option: '1/4oz', price: 40 },
    ],
    image: '/images/weed.png',
    category: 'Flower',
    description: 'A potent hybrid with sweet vanilla flavor and balanced effects.',
    effects: ['Relaxed', 'Happy', 'Euphoric'],
    flavors: ['Vanilla', 'Sweet', 'Creamy']
  },

  // Edibles (5 products)
  {
    id: 14,
    name: 'Trolli Gummi Candy',
    strain: 'Hybrid',
    thcContent: 600 ,
    price: 25,
    image: '/images/troll.png',
    category: 'Edibles',
    isNew: true,
    description: 'Trolli Gummi Candy with 600mg THC each (5 pieces x 100 special offer).',
    effects: ['Strong','Happy', 'Relaxed'],
    flavors: ['Sour', 'Sweet', 'Fruity'],
    dosage: '10mg THC per piece'
  },
  {
    id: 15,
    name: 'Faded',
    strain: 'Hybrid',
    thcContent: 1000,
    price: 25,
    image: '/images/fadd.png',
    category: 'Edibles',
    description: 'Faded Gummi with 1000mg THC each (5 pieces x 100 special offer).',
    effects: ['Strong','Happy', 'Relaxed'],
    flavors: ['Sour', 'Sweet', 'Fruity'],
    dosage: '5mg THC per piece'
  },
  // {
  //   id: 16,
  //   name: 'Stony Patch',
  //   strain: 'Sativa',
  //   thcContent: 500,
  //   price: 25,
  //   image: '/images/stp.png',
  //   category: 'Edibles',
  //   description: 'Stony Patch Gummi with 500mg THC each (6 pieces x 100 special offer).',
  //   effects: ['Strong','Happy', 'Relaxed'],
  //   flavors: ['Sour', 'Sweet', 'Fruity'],
  //   dosage: '15mg THC per piece'
  // },
  {
    id: 17,
    name: 'Peach Gummi',
    strain: 'Sativa',
    thcContent: 1000,
    price: 25,
    image: '/images/gmm.png',
    category: 'Edibles',
    description: 'Peach Gummi with 1000mg THC each (5 pieces x 100 special offer).',
    effects: ['Strong','Happy', 'Relaxed'],
    flavors: ['Sour', 'Sweet', 'Fruity'],
    dosage: '20mg THC per piece'
  },
  {
    id: 18,
    name: 'Sour rings',
    strain: 'Hybrid',
    thcContent: 600,
    cbdContent: 5,
    price: 25,
    image: '/images/ring.png',
    category: 'Edibles',
    description: 'Sour rings Gummi with 600mg THC each (5 pieces x 100 special offer).',
    effects: ['Strong','Happy', 'Relaxed'],
    flavors: ['Sour', 'Sweet', 'Fruity'],
    dosage: '5mg THC + 5mg CBD per piece'
  },

  // Concentrates (2 products)
  // {
  //   id: 19,
  //   name: 'Moon Rock',
  //   strain: '',
  //   // thcContent: 50,
  //   price: 50,
  //   image: '/images/moo.png',
  //   category: 'Concentrates',
  //   description: 'THC tinctures emerge as an ideal choice for non-smokers or those seeking a discreet and rapidly effective cannabis solution.',
  //   effects: ['Strong', 'Euphoric', 'Creative'],
  //   flavors: ['Dank', 'Pine', 'Citrus'],
  //   consistency: 'Sauce'
  // },
  // {
  //   id: 20,
  //   name: 'Shatter',
  //   strain: '5g shatter',
  //   // thcContent: 80,
  //   price: 50,
  //   image: '/images/shtt.png',
  //   category: 'Concentrates',
  //   description: 'Glass-like concentrate with high potency and clean flavor.',
  //   effects: ['Potent', 'Relaxing', 'Sleepy'],
  //   flavors: ['Earthy', 'Sweet', 'Pungent'],
  //   consistency: 'Glass-like'
  // },

  // Cartridges (4 products)
  // {
  //   id: 21,
  //   name: 'Raw Garden',
  //   strain: 'indica',
  //   // thcContent: 85,
  //   price: 25,
  //   image: '/images/raw.png',
  //   category: 'cart',
  //   description: 'Raw Garden vape cartridges generally offer a sweet, fruity flavor profile with indica-dominant effects.',
  //   effects: ['Happy', 'Relaxed', 'Euphoric'],
  //   flavors: ['Sweet', 'Creamy', 'Berry'],
  //   cartridgeType: '510 Thread'
  // },
  {
    id: 22,
    name: 'Muha Meds',
    strain: 'Indica',
    // thcContent: 82,
    price: 30,
    image: '/images/muha.png',
    category: 'cart',
    description: 'Muha Meds delivers a refreshing and juicy experience, reminiscent of biting into a ripe watermelon.',
    effects: ['Energetic', 'Creative', 'Uplifted'],
    flavors: ['Orange', 'Citrus', 'Tangy'],
    cartridgeType: '510 Thread'
  },
  {
    id: 23,
    name: 'Friendly Farms',
    strain: 'Indica',
    // thcContent: 83,
    price: 30,
    image: '/images/fri.png',
    category: 'cart',
    description: 'Friendly Farms effects makes you feel uplifted, happy, and relaxed.',
    effects: ['Relaxing', 'Sleepy', 'Happy'],
    flavors: ['Grape', 'Berry', 'Sweet'],
    cartridgeType: '510 Thread'
  },
  {
    id: 24,
    name: 'Friendly Farms',
    strain: 'Sativa',
    // thcContent: 79,
    price: 30,
    image: '/images/fri2.png',
    category: 'cart',
    description: 'Friendly Farms effects makes you feel uplifted, happy, and relaxed.',
    effects: ['Energetic', 'Happy', 'Creative'],
    flavors: ['Strawberry', 'Sweet', 'Fruity'],
    cartridgeType: '510 Thread'
  },

  // Disposable Carts (4 products)
  {
    id: 25,
    name: 'Boutiq Switch',
    strain: 'Indica',
    // thcContent: 90,
    price: 60,
    image: '/images/jeee.png',
    category: 'disposable-cart',
    weight: '2g',
    description: 'Boutiq Switch Glow 2g vape offers 3 strains in one device, Liquid Diamonds.',
    effects: ['Energetic', 'Creative', 'Uplifted'],
    flavors: ['Pineapple', 'Mango', 'Tropical'],
    battery: '300mAh'
  },
  {
    id: 26,
    name: 'Drip Disposable',
    strain: 'Indica',
    // thcContent: 88,
    price: 50,
    image: '/images/drip.png',
    category: 'disposable-cart',
    weight: '2g',
    description: ' Two flavors in one 2-gram item, giving a smooth interplay of freshness, strength, and diversity of taste.',
    effects: ['Relaxing', 'Sleepy', 'Happy'],
    flavors: ['Blueberry', 'Sweet', 'Earthy'],
    battery: '350mAh'
  },
  {
    id: 27,
    name: 'Muha Meds Disposable',
    strain: '',
    // thcContent: 86,
    price: 50,
    image: '/images/raww.png',
    category: 'disposable-cart',
    weight: '2g',
    description: 'Muha Meds 2g Disposable offers a sleek, ready-to-use device packed with premium oil for smooth, flavorful hits.',
    effects: ['Energetic', 'Creative', 'Focused'],
    flavors: ['Orange', 'Citrus', 'Champagne'],
    battery: '300mAh'
  },
  // {
  //   id: 28,
  //   name: 'Forbidden Fruit Disposable',
  //   strain: 'Indica',
  //   // thcContent: 87,
  //   price: 65,
  //   image: '/images/pac.png',
  //   category: 'disposable-cart',
  //   weight: '2g',
  //   description: '2g Disposable Exotics Edition variety pack 2 gram disposable, Liquid Diamonds.',
  //   effects: ['Relaxing', 'Euphoric', 'Happy'],
  //   flavors: ['Tropical', 'Sweet', 'Fruity'],
  //   battery: '320mAh'
  // },

  // Pre-rolls (2 products)
  {
    id: 29,
    name: 'Pre-Roll - Sativa',
    strain: 'Sativa',
    // thcContent: 20,
    weight: '1g',
    price: 10,
    image: '/images/prr.png',
    category: 'Pre-rolls',
    description: '1 premium sativa pre-rolls (1g each).',
    effects: ['Our Pre-roll special'],
    flavors: ['10 Sativa Pre-rolls for 80', '20 Sativa Pre-rolls + 1 Edible 160 '],
    quantity: '3 pre-rolls (1g each)'
  },
  {
    id: 30,
    name: 'Pre-Roll - Indica',
    strain: 'Indica',
    weight: '1g',
    // thcContent: 22,
    price: 10,
    image: '/images/prr1.png',
    category: 'Pre-rolls',
    description: '10 premium indica pre-rolls (1g each).',
    effects: ['Our Pre-roll special'],
    flavors: ['10 Indica Pre-rolls for 80', '20 Indica Pre-rolls + 1 Edible 160 '],
    quantity: '1 pre-rolls (1g each)'
  },
  {
    id: 31,
    name: 'Premium Shake - Indica',
    strain: 'Indica',
    weight: '1 oz',
    price: 80,
    image: '/images/shake.png',
    category: 'Shake',
    description: '1 Oz Premium Shake - Indica.',
  },
  {
    id: 32,
    name: 'Premium Shake - Sativa',
    strain: 'Sativa',
    weight: '1 oz',
    price: 80,
    image: '/images/shake.png',
    category: 'Shake',
    description: '1 Oz Premium Shake - Sativa.',
  },

    {
    id: 333,
    name: '2 Oz Exotic Flower Special',
    strain: '',
    weight: '2 Oz',
    price: 380,
    image: '/images/blue.png',
    category: 'Deals',
    description: 'your choice of 2 Oz  exotic flower. (mix and match any of our exotic flower for 380)',
  },
  {
    id: 313,
    name: '10 premium pre-rolls',
    strain: '',
    weight: '1 g',
    price: 80,
    image: '/images/prr.png',
    category: 'Deals',
    description: '10 premium pre-rolls for 80',
  },
  {
    id: 33,
    name: '4 Carts Special',
    strain: '',
    weight: '4 carts',
    price: 100,
    image: '/images/fri.png',
    category: 'Deals',
    description: 'your choice of 4 carts for 100',
  },
  // {
  //   id: 333,
  //   name: '10 Carts Special',
  //   strain: '',
  //   weight: '10 carts',
  //   price: 180,
  //   image: '/images/fri.png',
  //   category: 'Deals',
  //   description: 'your choice of 10 carts for 180',
  // },
  {
    id: 34,
    name: '5 Edibles Special',
    strain: '',
    weight: ' Edibles',
    price: 100,
    image: '/images/edd.png',
    category: 'Deals',
    description: 'your choice of 5 Edibles for 100',
  },
  // {
  //   id: 35,
  //   name: '10 Edibles Special',
  //   strain: '',
  //   weight: '10 Edibles',
  //   price: 180,
  //   image: '/images/gmm.png',
  //   category: 'Deals',
  //   description: 'your choice of 10 carts for 180',
  // },
  {
    id: 36,
    name: '2 Disposables Special (2g)',
    strain: '2g',
    weight: '2 2g Disposables',
    price: 80,
    image: '/images/dv.png',
    category: 'Deals',
    description: 'your choice of 2 Disposables for 80',
  },
  // {
  //   id: 37,
  //   name: '10 Disposables Special(1g)',
  //   strain: '1g',
  //   weight: '10 1g Disposables',
  //   price: 280,
  //   image: '/images/dv.png',
  //   category: 'Deals',
  //   description: 'your choice of 10 Disposables for 280',
  // },
  // {
  //   id: 38,
  //   name: '4 Disposables Special (2)',
  //   strain: '2g',
  //   weight: '4 2g Disposables',
  //   price: 240,
  //   image: '/images/3gg.png',
  //   category: 'Deals',
  //   description: 'your choice of 4 Disposables for 240',
  // },
  // {
  //   id: 39,
  //   name: '10 Disposables Special(2g)',
  //   strain: '2g',
  //   weight: '10 2g Disposables',
  //   price: 580,
  //   image: '/images/3gg.png',
  //   category: 'Deals',
  //   description: 'your choice of 10 Disposables for 580',
  // },
  // {
  //   id: 40,
  //   name: '10g Shatter Special',
  //   strain: '10g',
  //   weight: '10g Shatter',
  //   price: 200,
  //   image: '/images/shtt.png',
  //   category: 'Deals',
  //   description: '10g Shatter for 200',
  // },
  // {
  //   id: 41,
  //   name: '28g Shatter Special',
  //   strain: '1 Oz',
  //   weight: '28g Shatter',
  //   price: 500,
  //   image: '/images/shtt.png',
  //   category: 'Deals',
  //   description: '28g Shatter (1 Oz) for 500',
  // }
];

export default products;